angular.module('rjmNg.directives').directive "emailSummaryEdit", [
  () ->
    restrict: "E"
    templateUrl: "directive.emailSummaryEdit.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      '$scope'
      '$location'
      '$q'
      '$routeParams'
      'appRoute'
      'EmailSummary'
      'Figures'
      'figureEnums'
      'notification'
      'Clients'
      'userService'
      ($scope, $location, $q, $routeParams, appRoute, EmailSummary, Figures, figureEnums, notification, Clients, userService) ->

        view = @

        _allReports = []
        _allReportsMap = {}
        _editId = null
        _recipientListValid = false
        _name = ''
        _notificationTimeout = 20
        _scheduleValid = false

        view.groups = []  # Initialize groups array for select box
        view.selectedGroup = 0
        view.availReports = []
        view.canSave = false
        view.displayName = 'Untitled Email Summary'
        view.displayTypes = figureEnums.PRESENTATION_TYPES
        view.emailSchedule = null
        view.esListLink = appRoute('/settings/email-summary/')
        view.isDirty = false
        view.isEdit = false
        view.loading = false
        view.maxReports = 10
        view.recipientList = []
        view.reportOptions = [{}] #Init with initialValue
        view.selectedReports = {}
        view.sendToMe = true
        view.clientId = $routeParams.clientId


        # Fetch user emails based on selected group
        # view.fetchUserEmails = (groupId) ->
          
        #   userService.emails({ clientId: view.clientId, groupId: groupId }).then (response) ->
        #     fetchedEmails = response.data.map((email) -> email.email)
        #     # Filter out duplicates and add only unique emails
        #     uniqueEmails = fetchedEmails.filter((email) -> view.recipientList.indexOf(email) == -1)
        #     view.recipientList = view.recipientList.concat(uniqueEmails)
        #   .catch (error) ->
        #     notification.error("Server Error",
        #         errorConstants.SERVER_ERROR_MESSAGE,
        #         "email-selection",
        #         null,
        #         15
        #       )

        # Function to fetch data from the API and populate groups
        view.fetchData = ->
          
          userService.stores({clientId: view.clientId}).then (response) ->
            allStores = response.data
            # Populate 'groups' with group names and ids for ng-options
            view.groups = allStores.map (group) ->
              id: group.id
              name: group.name
            
          .catch (error) ->
            _handleGenericError(error)  

        # Fetch client data and then fetch groups
        Clients.get($routeParams.clientId)
         .then ({properties}) ->
           {is_group_store_access} = properties
           view.isAdvancedUserMng = is_group_store_access is "1"
           if view.isAdvancedUserMng
             view.fetchData()  # Call fetchData after client data is fetched
           

        _resolveErrorMessage = (error) ->
          err = error.data?.message
          return if err? then err else ""

        _handleEmailLoadError = (error) ->
          switch(error.status)
            when 404
              _notify('error', 'Error 404 Email Summary Not Found', 'emailSummaryList')
              $location.path(view.esListLink)
            else
              _notify('error', 'Email Load Error: ' + error.status + ' ' + _resolveErrorMessage(error))

        _handleGenericError = (error) ->
          _notify('error', 'Error ' + error.status + ' ' + _resolveErrorMessage(error))
        
        _handleSaveError = (error) ->
          outMsg = error.data.message
          if(error.data.errors?)
            outMsg = _.reduce(error.data.errors, (accu, val, key) ->
              accu+='Key: ' + key + ' Error: ' + val + ', '
            '')
            outMsg = outMsg.slice(0, -2)
          _notify('error', 'Save Error ' + error.status + ' ' + outMsg)

        _initFields = (es) ->
          if(es.email_summary?)
            esInfo = es.email_summary
            view.selectedReports = _.chain(esInfo.items)
                                    .filter((rep) ->
                                      return _allReportsMap[rep.item_id]
                                    )
                                    .reduce((accu, item, ix) ->
                                      tmpRep = _allReportsMap[item.item_id]
                                      if (tmpRep)
                                        accu[ix] = tmpRep
                                        accu[ix].displayType = item.type
                                        if(ix > 0)
                                          view.reportOptions.push({})
                                      
                                      return accu
                                    , {})
                                    .value()
            view.displayName = _name = esInfo.name
            view.sendToMe = esInfo.send_to_me
            view.selectedGroup = esInfo.group_access_id
            view.emailSchedule = esInfo.schedule
            view.recipientList = esInfo.bccs

            _setAvailReports()
            _validateEmailSummary()

        _isNotSelectedReport = (rep) ->
          output = _.chain(view.selectedReports)
           .values()
           .pluck('id')
           .contains(rep.id)
           .value()
          return not output

        _loadSummary = (esId) ->
          output = $q.resolve(false)
          if(esId)
            output = EmailSummary.get(esId)
          return output

        _notify = (type, msg, scope) ->
          notifyFn = notification.info
          switch type
            when 'error' then notifyFn = notification.error
            when 'success' then notifyFn = notification.success
            else notifyFn = notification.info
          notifyFn(type, 
                   msg, 
                   if(scope) then scope else 'emailSummaryEdit',
                   null,
                   _notificationTimeout)

        _saveEmail = () ->
          _saveFn = EmailSummary.create
          if(view.isEdit)
            _saveFn = EmailSummary.update.bind(this, _editId)

          emailToSave = {
            es_map: {
              name: _name,
              subject: 'null',
              send_to_me: view.sendToMe,
              group_access_id: view.selectedGroup
            },
            schedule: view.emailSchedule
            bccs: view.recipientList
            items: _.values(view.selectedReports).map((rep) ->
              return { type: rep.displayType, item_id: rep.id}
            )
          }

          # Manual Email Summaries need to be set to active status
          # to prevent the UI from disabling the "Send Now" button in the list page sprocket menu
          if(view.emailSchedule.frequency is 0)
            # TODO this means an email summary could be "un-deleted"
            # TODO   if a deleted email summary would ever be allowed make it to the edit page
            emailToSave.es_map.status = 1

          return _saveFn(emailToSave)

        _sendEmail = () ->
          return EmailSummary.send(_editId)

        _setAvailReports = () ->
          view.availReports = _.chain(_allReports)
                               .filter(_isNotSelectedReport)
                               .sortBy((report) -> report.name.toUpperCase())
                               .value();

        _validateEmailSummary = () ->
          view.canSave = false
          view.errorList = []
          _isValid = true
          _errorList = []
          unless (_name)
            _isValid = false
            _errorList.push('Invalid Name')
          unless (_validateReports())
            _isValid = false
            _errorList.push('Invalid Report Selection')
          unless (_validateReportTypes())
            _isValid = false
            _errorList.push('Some reports have invalid display types')
          unless (_scheduleValid)
            _isValid = false
            _errorList.push('Invalid Schedule Selection')
          if (view.recipientList.length is 0 and not view.sendToMe)
            _isValid = false
            _errorList.push('Must send to self or add recipient')
          if (view.recipientList.length > 0 and not _recipientListValid)
            _isValid = false
            _errorList.push('Invalid Recipient List')
          view.canSave = _isValid
          view.errorList = _errorList

        _validateReports = () ->
          return Object.keys(view.selectedReports).length is view.reportOptions.length

        _validateReportTypes = () ->
          return _.every(
            Object.values(view.selectedReports),
            (report) ->
              if report.type is view.displayTypes.SCALAR
                return report.displayType is view.displayTypes.SCALAR
              else if report.type in [view.displayTypes.HIGHCHARTS, view.displayTypes.TABLE]
                return report.displayType in [view.displayTypes.HIGHCHARTS, view.displayTypes.TABLE]
              else
                return true
          )

        view.addReportOption = () ->
          if(view.reportOptions.length < view.maxReports)
            view.reportOptions.push({})
          _setAvailReports()
          _validateEmailSummary()

        view.emailsUpdate = (isValid, emailList) ->
          _recipientListValid = isValid
          view.recipientList = emailList
          _validateEmailSummary()

        view.removeReportOption = (ix) ->
          if(view.selectedReports[ix])
            delete view.selectedReports[ix]
          view.reportOptions.splice(ix, 1)
          view.selectedReports = _.reduce(view.selectedReports, (accu, val, key) -> 
            if(parseInt(key, 10) > ix)
              accu[key - 1] = val
            else
              accu[key] = val
            return accu
          ,{})
          _setAvailReports()
          _validateEmailSummary()

        view.save = () ->
          view.loading = true
          _saveEmail().then((success) ->
            _notify('success', 'Saved Email Summary Successfully')
            if(!view.isEdit)
              $location.path(appRoute('/settings/email-summary/edit/' + success.id))
          ,(error) ->
            _handleSaveError(error)
          ).finally(() ->
            view.loading = false
          )

        view.saveAndSend = () ->
          view.loading = true
          _saveEmail().then((success) ->
            if(!view.isEdit)
              _editId = success.id
            _sendEmail().then((sendSuccess) ->
              _notify('success', 'Saved Email Summary and queued send successfully')
            ,(sendError)->
              _notify('error', 'Error sending email summary.')
            ).finally(()->
              if(!view.isEdit)
                $location.path(appRoute('/settings/email-summary/edit/' + success.id))
            )
          ,(error) ->
            _notify('error', 'Error sending email summary.')
          ).finally(() ->
            view.loading = false
          )

        view.scheduleUpdate = (isValid, emailSchedule) ->
          _scheduleValid = isValid
          view.emailSchedule = emailSchedule
          _validateEmailSummary()

        view.setDisplayType = (item, $index) ->
          view.selectedReports[$index].displayType = item
          _validateEmailSummary()

        view.setSendToMe = (val) ->
          view.sendToMe = val
          _validateEmailSummary()
        
        view.setGroupAccessId = () ->
          view.selectedGroup = 0
          _validateEmailSummary()

        view.setReports = (item, $index) ->
          view.selectedReports[$index] = item
          view.selectedReports[$index].displayType = item.type
          _setAvailReports()
          _validateEmailSummary()

        view.focusName = () ->
          if(_name.trim() is '')
            view.displayName = ''

        view.unfocusName = () ->
          if(_name.trim() is '')
            view.displayName = 'Untitled Email Summary'

        view.validateName = ($event) ->
          view.isDirty = true
          _name = if ($event.target.value) then $event.target.value.trim() else $event.target.value
          view.displayName = _name
          _validateEmailSummary()

        view.$postLink = () ->
          view.loading = true
          if($routeParams.esId)
            _editId = $routeParams.esId
            view.isEdit = true
          $q.all({
            figures: Figures.getAllFigures()
            es: _loadSummary(_editId)
          }).then((success) ->
            _allReports = angular.copy(success.figures)
            _allReportsMap = _allReports.reduce((accu, report) -> 
              accu[report.id] = report
              return accu
            ,{})
            if(success.es)
              _initFields(success.es)
            _setAvailReports()
          ,(error) ->
            if(error.data?.reqOrigin is 'EmailSummary')
              _handleEmailLoadError(error)
            else
              _handleGenericError(error)
          ).finally(() ->
            view.loading = false
          )

        return view
    ]
]
